import { featuredTopic, topicCollections } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function TopicCollections() {
  return (
    <section id="collections" className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="主题合集"
        title="按主题打包好的合集，一眼看完一类内容"
        desc="每个合集都把同一主题下的分散条目归到一处，附来源与标签，省去反复翻页和到处收集的麻烦。"
        linkLabel="查看全部合集"
        linkHref="#latest"
      />

      <a
        href="#latest"
        className="group relative block aspect-[16/10] w-full overflow-hidden rounded-xl sm:aspect-[21/9] cursor-pointer"
      >
        <img
          src={featuredTopic.cover}
          alt={`${featuredTopic.title} 封面`}
          title={`${featuredTopic.title} 黑料91黑料仓库专题合集`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 flex flex-col gap-3 p-5 md:flex-row md:items-end md:justify-between md:p-8">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-[11px] font-medium text-foreground-950">
              <i className="ri-star-smile-line" />
              {featuredTopic.badge}
            </span>
            <h3 className="mt-3 font-heading text-xl font-bold text-white md:text-3xl">
              {featuredTopic.title}
            </h3>
            <p className="mt-2 hidden text-sm leading-relaxed text-white/75 sm:block">
              {featuredTopic.desc}
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2 text-xs text-white/80">
            <span className="rounded-full border border-white/25 bg-white/10 px-3 py-1 backdrop-blur-sm">
              {featuredTopic.count}
            </span>
            {featuredTopic.tags.map((tag) => (
              <span
                key={tag}
                className="rounded-full border border-white/25 bg-white/10 px-3 py-1 backdrop-blur-sm"
              >
                {tag}
              </span>
            ))}
            <span className="flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 font-medium text-background-50">
              <i className="ri-time-line" />
              {featuredTopic.updated}
            </span>
          </div>
        </div>
      </a>

      <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {topicCollections.map((topic) => (
          <a
            key={topic.title}
            href="#latest"
            className="group flex flex-col overflow-hidden rounded-xl border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300 cursor-pointer"
          >
            <div className="relative h-44 w-full overflow-hidden md:h-48">
              <img
                src={topic.cover}
                alt={`${topic.title} 封面`}
                title={`${topic.title} 黑料91黑料资源合集`}
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-foreground-950/80 px-2.5 py-1 font-label text-[11px] text-background-100 backdrop-blur-sm">
                <i className="ri-stack-line text-accent-300" />
                {topic.count} 条
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4 md:p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                {topic.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                {topic.desc}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-1.5">
                {topic.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-900"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3 text-[11px] text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-time-line" />
                  {topic.updated}
                </span>
                <span className="flex items-center gap-1 text-primary-600">
                  进入合集
                  <i className="ri-arrow-right-up-line" />
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}